module.exports = __webpack_public_path__ + "img/landing_hero_banner_mobile.d471bae1.jpg";